module.exports = __webpack_public_path__ + "img/tab_unselected_black.d5b1693b.svg";